export default {
  // 首页
  'nft.banner_desc': 'We connect creators and collectors helping them generate joy and revenues.',
  'nft.banner_title': 'Welcome to Biconomy’s special NFT platform',
  'nft.banner_btn': 'My NFTs',
  'nft.list_title': 'Recommended Creators',
  'nft.become': 'How to Become A Creator and Sell Your NFTs?',
  'nft.become_title_1': 'Apply for Membership',
  'nft.become_desc_1':
    'After filling in the application form, we will have someone responsible for contacting you to communicate the specific process of joining.',
  'nft.become_title_2': 'Add NFTs',
  'nft.become_desc_2':
    'Upload your work (image or audio/video), add name and description, and customize your NFT with attributes and unlockable content.',
  'nft.become_title_3': 'Sell NFTs',
  'nft.become_desc_3': 'You can choose to sell at a fixed price or auction, and set the currency and time of sale.',
  'nft.faq_title': 'FAQs About Biconomy NFT',

  // 机构主页
  'nft.list': 'Listed Items',
  'filters': 'filters',
  'recently_listed': 'Recently Listed',
  'created_by': 'created by',
};
